import { CallsWidget } from '../../../../../features/composableAnalytics/DerivedCharts/helper';
import { renderCellFor } from '../../helper';
import { IPostgreCommunicationDTO } from '../../jobs/types/postgreJobsDTO';

export const getColumnsForCalls = (
  widgetName: CallsWidget,
  widgetData: IPostgreCommunicationDTO
) => {
  const uniqueDates = Array.from(
    new Set(widgetData?.resultSet?.flatMap((record) => Object.keys(record?.countsByDate ?? {})))
  );
  const uniqueStatus = Array.from(
    new Set(widgetData?.resultSet?.flatMap((record) => Object.keys(record?.statusWithCount ?? {})))
  );
  switch (widgetName) {
    case CallsWidget.RECRUITER_TABLE:
      return [
        {
          field: 'recruiterName',
          headerName: 'Recruiter Name',
          width: 180,
          renderCell: (params) => renderCellFor('RECRUITER', params),
        },
        { field: 'count', headerName: `Total Count(${widgetData?.count ?? 0})`, width: 150 },
        ...uniqueDates.map((date) => ({
          field: date,
          headerName: date,
          width: 110,
        })),
      ];
    case CallsWidget.RECRUITER_DIRECTION_TABLE:
      return [
        {
          field: 'recruiterName',
          headerName: 'Recruiter Name',
          width: 180,
          renderCell: (params) => renderCellFor('RECRUITER', params),
        },
        { field: 'direction', headerName: 'Direction', width: 100 },
        { field: 'count', headerName: `Total Count(${widgetData?.count ?? 0})`, width: 150 },
        ...uniqueDates.map((date) => ({
          field: date,
          headerName: date,
          width: 110,
        })),
      ];
    case CallsWidget.RECRUITER_STATUS_TABLE:
      return [
        {
          field: 'recruiterName',
          headerName: 'Recruiter Name',
          width: 180,
          renderCell: (params) => renderCellFor('RECRUITER', params),
        },
        { field: 'count', headerName: `Total Count(${widgetData?.count ?? 0})`, width: 150 },
        ...uniqueStatus.map((status) => ({
          field: status,
          headerName: status,
          width: 110,
        })),
      ];
    default:
      throw new Error('Invalid table widget name');
  }
};

export function getTableDataForCalls(
  widgetName: CallsWidget,
  widgetData: IPostgreCommunicationDTO
) {
  const uniqueDates = Array.from(
    new Set(widgetData?.resultSet?.flatMap((record) => Object.keys(record?.countsByDate ?? {})))
  );
  const uniqueStatus = Array.from(
    new Set(widgetData?.resultSet?.flatMap((record) => Object.keys(record?.statusWithCount ?? {})))
  );
  switch (widgetName) {
    case CallsWidget.RECRUITER_TABLE:
    case CallsWidget.RECRUITER_DIRECTION_TABLE:
      widgetData?.resultSet?.forEach((record, index) => {
        record.id = index;
        uniqueDates.forEach((date) => {
          record[date] = record?.countsByDate?.[date] || 0;
        });
      });
      return widgetData?.resultSet;
    case CallsWidget.RECRUITER_STATUS_TABLE:
      widgetData?.resultSet?.forEach((record, index) => {
        record.id = index;
        uniqueStatus.forEach((status) => {
          record[status] = record?.statusWithCount?.[status] || 0;
        });
      });
      return widgetData?.resultSet;
    default:
      return [];
  }
}
